import React from 'react';
import ReactQuill from 'react-quill';

const ReduxQuill = ({ input }) => {
    this.modules = {
        toolbar: [
            [{'header':1}, {'header':2}],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link', 'video'], //removed 'image' since it jams it into the db TODO make this upload to django with a custom quill handler
            [{ 'color': [] }],
            ['clean']
        ],
    };
    return (
        <ReactQuill
            modules={this.modules}
            {...input}
            onChange={(newValue, delta, source) => {
                if (source === 'user') {
                  input.onChange(newValue);
                }
            }}
            onBlur={(range, source, quill) => {
                input.onBlur(quill.getHTML());
            }}
        />
    );
};

export default ReduxQuill


// WEBPACK FOOTER //
// ./src/common/ReduxQuill.js